// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCarousel from 'vue-carousel'
import progressive from 'progressive-image/dist/vue'
import { VTooltip, VPopover } from 'v-tooltip'
import moment from 'moment'
import Pikaday from 'pikaday'
import 'pikaday/scss/pikaday.scss'

import App from './App'
import constants from './constants'
import router from './router'
import store from './store'
import utils from './utils'
import validator from './Validator'

import './css/vender/normalize.css'
import 'bootstrap/scss/bootstrap.scss'
import 'progressive-image/dist/index.css'
import './css/style.scss'

navigator.sayswho = () => {
  let ua = navigator.userAgent
  let tem
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return 'IE ' + (tem[1] || '')
  }

  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
    if (tem !== null) return tem.slice(1).join(' ').replace('OPR', 'Opera')
  }

  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i)) !== null) M.splice(1, 1, tem[1])
  return M.join(' ')
}

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(VueCarousel)
Vue.use(progressive, {
  removePreview: true,
  scale: false
})
Vue.directive('tooltip', VTooltip)
Vue.component('v-popover', VPopover)

Vue.directive('pikaday', {
  inserted: (el, binding, vnode) => {
    const opts = {
      field: el,
      format: 'DD/MM/YYYY',
      onSelect: () => {
        binding.value.call(vnode.context, el.value)
      }
    }
    if (el.hasAttribute('maxDate')) opts.maxDate = moment(el.getAttribute('maxDate')).toDate()
    // eslint-disable-next-line no-unused-vars
    const picker = new Pikaday(opts)
  }
})

Vue.config.WEBSITE_NAME = process.env.WEBSITE_NAME
Vue.config.WEBSITE_EMAIL = process.env.WEBSITE_EMAIL
Vue.config.DOMAIN = process.env.DOMAIN
Vue.config.API_URL = process.env.API_URL
Vue.config.WS_URL = process.env.WS_URL
Vue.config.FB_APP_ID = process.env.FB_APP_ID
Vue.config.PAYMENT_TIMEOUT = 30 * 1000 // timeout before recheck
Vue.config.PAYMENT_RECHECK_INTERVAL = 5 * 1000 // recheck interval
Vue.config.PAYMENT_RECHECK_TIMEOUT = 30 * 1000 // recheck interval
Vue.config.PAYPAL_SANDBOX = process.env.PAYPAL_SANDBOX
Vue.config.PAYPAL_CLIENT_ID = process.env.PAYPAL_CLIENT_ID
Vue.config.OMISE_KEY = process.env.OMISE_KEY
Vue.config.MAIN_WEBSITE_URL = process.env.MAIN_WEBSITE_URL
Vue.config.WP_CAMPAIGN_URL = process.env.WP_CAMPAIGN_URL
Vue.config.AVAILABLE_PAYMENT_METHOD = process.env.AVAILABLE_PAYMENT_METHOD
Vue.config.AVAILABLE_MONTHLY_PAYMENT_METHOD = process.env.AVAILABLE_MONTHLY_PAYMENT_METHOD
Vue.config.OMISE_INTERNET_BANKING = process.env.OMISE_INTERNET_BANKING
Vue.config.BANK_TRANSFER = process.env.BANK_TRANSFER
Vue.config.PRODUCT_TYPE = process.env.PRODUCT_TYPE
Vue.config.DEFAULT_PLAN_CODE = process.env.DEFAULT_PLAN_CODE
Vue.config.TMB_API_URL = process.env.TMB_API_URL
Vue.config.TMB_MERCHANT_ID = process.env.TMB_MERCHANT_ID
Vue.config.MAIN_PRODUCT_SKU = process.env.MAIN_PRODUCT_SKU
Vue.config.MONTHLY_OPTION_PRIVATE = process.env.MONTHLY_OPTION_PRIVATE
Vue.config.DAILY_OPTION_ENABLED = process.env.DAILY_OPTION_ENABLED

Vue.http.options.root = Vue.config.API_URL + '/' + Vue.config.DOMAIN + '/'

Vue.http.interceptors.push((request, next) => {
  const autoLogout = request.autoLogout === undefined ? true : request.autoLogout

  next(response => {
    if (autoLogout && response.status === 401) {
      store.dispatch('logout')
      router.push('/user/login')
    }
  })
})

Vue.use(utils)
Vue.use(constants)
Vue.use(validator)
Vue.use({
  install (Vue, options) {
    Vue.prototype.$config = Vue.config
  }
})

function comma (value) {
  return value && value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

function safeTags (str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

Vue.filter('newLineToBr', value => {
  return value && safeTags(value).replace(/\n/g, '<br>')
})

Vue.filter('comma', value => {
  return comma(value)
})

Vue.filter('money', value => {
  return value && comma(parseFloat(value).toFixed(2))
})

Vue.filter('defaultValue', (value, fallback) => {
  return value || fallback
})

Vue.filter('date', value => {
  let d = new Date(value)
  let year = d.getFullYear()
  if (year > 3000) {
    d = new Date(Math.round(value / 1000))
  }
  return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear()
})

function pad (value) {
  return `${value}`.replace(/^(\d)$/, '0$1')
}

Vue.filter('datetime', value => {
  let d = new Date(value)
  let year = d.getFullYear()
  if (year > 3000) {
    d = new Date(Math.round(value / 1000))
  }
  return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
})

Vue.filter('period', (value) => {
  const secondLeft = Math.floor(value / 1000)
  const hours = Math.floor(secondLeft / 3600)
  const minutes = Math.floor((secondLeft % 3600) / 60)
  const seconds = secondLeft - (hours * 3600) - (minutes * 60)
  const textHour = hours ? `${hours} ชั่วโมง ` : ''
  const textMinute = minutes ? `${minutes} นาที ` : ''
  return `${textHour}${textMinute}${seconds} วินาที`
})

let debounceCallbacks = {}
const debounce = (cb, timeout) => {
  let timer = debounceCallbacks[cb]

  if (timer) {
    clearTimeout(timer)
  }

  debounceCallbacks[cb] = timer = setTimeout(cb, timeout)
}

const updateSticky = (el, opts) => {
  const body = document.querySelector('body')
  const parent = el.parentElement
  const ghost = parent.querySelector('.sidebar-ghost')

  ghost.innerHTML = el.innerHTML

  let updateFunc = () => {
    const scrollY = window.scrollY

    let triggerTop = opts.triggerTop
    let isTriggered
    if (triggerTop === 'auto') {
      triggerTop = parent.getBoundingClientRect().y
      isTriggered = triggerTop <= 10
    } else {
      isTriggered = scrollY > triggerTop
    }

    if (isTriggered) {
      ghost.style.display = 'block'

      setTimeout(() => {
        window.requestAnimationFrame(() => {
          if (ghost.style.display === 'none') {
            return
          }

          const bound = ghost.getBoundingClientRect()

          el.style.width = `${bound.width}px`

          if (opts.triggerBottom && (scrollY + el.offsetHeight + opts.triggerBottom >= body.offsetHeight)) {
            el.style.position = `absolute`
            el.style.top = ''
            el.style.bottom = `${opts.bottom}px`
            el.style.left = ``
          } else {
            el.style.position = `fixed`
            el.style.top = `${opts.top}px`
            el.style.bottom = ''
            el.style.left = `${bound.left}px`
          }
        })
      }, 10)
    } else {
      ghost.style.display = 'none'
      el.style.position = `static`
      el.style.width = ''
    }
  }

  let resetFunc = () => {
    ghost.innerHTML = el.innerHTML
    window.requestAnimationFrame(() => {
      updateFunc()
    })
  }

  return {
    update: updateFunc,
    reset: resetFunc
  }
}

function ensureFunc (object, checkFunc) {
  return new Promise((resolve, reject) => {
    const t = setInterval(() => {
      if (checkFunc(object)) {
        clearTimeout(t)
        resolve()
      }
    }, 100)
  })
}

Vue.directive('sticky', {
  bind: function (el, binding) {
    ensureFunc(el, el => el.getBoundingClientRect().width > 0).then(() => {
      const sticky = updateSticky(el, binding.value)

      el.$sticky = sticky
      el.$stickyWindowResizeHandler = ev => {
        debounce(sticky.reset, 10)
      }

      el.$stickyWindowScrollHandler = ev => {
        debounce(sticky.update, 10)
      }

      window.addEventListener('resize', el.$stickyWindowResizeHandler)
      window.addEventListener('scroll', el.$stickyWindowScrollHandler)
    })
  },
  componentUpdated: function (el, binding) {
    if (el.$sticky) {
      debounce(el.$sticky.reset, 10)
    }
  },
  unbind: function (el, binding) {
    window.removeEventListener('resize', el.$stickyWindowResizeHandler)
    window.removeEventListener('scroll', el.$stickyWindowScrollHandler)
  }
})

// inject opbeat
let _log = window.console.log
// eslint-disable-next-line no-global-assign
window.console.log = (...args) => {
  args.forEach(item => {
    if (item instanceof Error) {
      if (window.Raven) {
        Raven.captureException(item)
      }
      if (window._opbeat) {
        window._opbeat('captureException', item)
      }
    }
  })

  _log.call(window.console, ...args)
}

/* eslint-disable no-new */
function init () {
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
}

const Raven = window.Raven
if (Raven) {
  Raven.config('https://81062e94488546b6aa235d7fdb5665c1@sentry.opendream.co.th/11', {
    logger: 'javascript',
    environment: process.env.NODE_ENV
  }).install()

  Raven.context(function () {
    init()
  })
} else {
  init()
}



// WEBPACK FOOTER //
// ./src/main.js